import useApiPrivateClient from '../../../hooks/useApiPrivateClient';
import {
  CreatePromoCodeData,
  UpdatePromoCodeData,
} from './promoCode.requests';
import { PromoCode, PromoCodeStats } from './promoCode.responses';

const usePromoCodeService = () => {
  const api = useApiPrivateClient();

  const listPromoCodes = (params?: { partnerId?: string; isActive?: boolean }) =>
    api.get<PromoCode[]>('/payments/promos', { params });

  const getPromoCode = (id: string) =>
    api.get<PromoCode>(`/payments/promos/${id}`);

  const getPromoCodeStats = (id: string) =>
    api.get<PromoCodeStats>(`/payments/promos/${id}/stats`);

  const createPromoCode = (data: CreatePromoCodeData) =>
    api.post<PromoCode>('/payments/promos', data);

  const updatePromoCode = (id: string, data: UpdatePromoCodeData) =>
    api.patch<PromoCode>(`/payments/promos/${id}`, data);

  const deactivatePromoCode = (id: string) =>
    api.delete<PromoCode>(`/payments/promos/${id}`);

  return {
    listPromoCodes,
    getPromoCode,
    getPromoCodeStats,
    createPromoCode,
    updatePromoCode,
    deactivatePromoCode,
  };
};

export default usePromoCodeService;
